/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    onClick: PropTypes.func.isRequired,
    buyerCount: PropTypes.number,
    sellerCount: PropTypes.number,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  render() {
    const {
      onClick,
      props: { activeTab, label },
    } = this;

    let className = 'tab-list-item';

    if (activeTab === label) {
      className += ' tab-list-active';
    }

    return (
      <li className={className} onClick={onClick}>
          {label}
          {typeof label === 'string' && label === 'ระบบซื้อ' && this.props.buyerCount > 0 ? (
            <span className='myshop-indicator' style={{ marginLeft: 8 }}>
              {this.props.buyerCount}
            </span>
          ) : null}
          {typeof label === 'string' && label === 'ระบบขาย' && this.props.sellerCount > 0 ? (
            <span className='myshop-indicator' style={{ marginLeft: 8 }}>
              {this.props.sellerCount}
            </span>
          ) : null}
      </li>
    );
  }
}

export default Tab;
